import { MemberType } from '@/api/members';
import { createSlice } from '@reduxjs/toolkit';

export const navSlice = createSlice({
  name: 'nav',
  initialState: {
    currentMember: {},
  },
  reducers: {
    setCurrentMember: (state, action) => {
      state.currentMember = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setCurrentMember } = navSlice.actions

export const getCurrentMember = (state: any) => state.auth.member as MemberType

export default navSlice.reducer